import { gtpToPoint, pointToLabel } from "../go/coordinates";
import { applyMove, opponent } from "../go/rules";
import type { Board, Color, Point } from "../go/types";

export interface ShadowMove {
  point: Point;
  color: Color;
  label: string;
  moveNumber: number;
}

interface ShadowVariationInput {
  board: Board;
  size: number;
  toPlay: Color;
  pv: string[];
  limit?: number;
}

export function shadowMovesFromPv({ board, size, toPlay, pv, limit = 12 }: ShadowVariationInput): ShadowMove[] {
  const moves: ShadowMove[] = [];
  let workingBoard = board.slice();
  let color = toPlay;

  for (const vertex of pv) {
    if (moves.length >= limit) {
      break;
    }

    const point = gtpToPoint(vertex, size);
    if (point) {
      const result = applyMove(workingBoard, size, point, color);
      if (result.ok) {
        workingBoard = result.board;
        moves.push({
          point,
          color,
          label: pointToLabel(point, size),
          moveNumber: moves.length + 1
        });
      }
    }

    color = opponent(color);
  }

  return moves;
}
